// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import '../../snippets/background-media/background-media';

// Styles
import './_hero-banner.scss';
import './_hero-banner--carousel.scss';
